module.exports = __webpack_public_path__ + "static/media/mail-check.b1d67f26.svg";